










import { computed, defineComponent, PropType, ref } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import { FillBackgroundType } from "../../../../../config";

export default defineComponent({
  name: "FontBackground",
  components: { BaseIconButton },
  props: {
    currentFillType: { type: String as PropType<FillBackgroundType> },
  },
  setup(props, { emit }) {
    const emptyBackground = ref(props.currentFillType === FillBackgroundType.EMPTY);
    const hasBackground = ref(props.currentFillType === FillBackgroundType.ACTIVE);
    const hasInvertBackground = ref(props.currentFillType === FillBackgroundType.ACTIVE_INVERT);
    const renderIcon = computed(() => {
      if (emptyBackground.value) return "sci-format-text";
      else if (hasBackground || hasInvertBackground) return "sci-format-text-highlight";
    });

    const changeBackgroundState = () => {
      if (emptyBackground.value && !hasBackground.value) {
        emptyBackground.value = !emptyBackground.value;
        hasBackground.value = !hasBackground.value;
        emit("changeFillType", FillBackgroundType.ACTIVE);
      } else if (hasBackground.value) {
        hasBackground.value = !hasBackground.value;
        hasInvertBackground.value = !hasInvertBackground.value;
        emit("changeFillType", FillBackgroundType.ACTIVE_INVERT);
      } else if (hasInvertBackground.value) {
        hasInvertBackground.value = !hasInvertBackground.value;
        emptyBackground.value = !emptyBackground.value;
        emit("changeFillType", FillBackgroundType.EMPTY);
      }
    };

    return {
      renderIcon,
      hasBackground,
      emptyBackground,
      hasInvertBackground,
      changeBackgroundState,
    };
  },
});
